<div class="re-submit-invoice-text" *ngIf="nextStep == 'Re-Submit Invoice'">
    <span class="font-mont-semi-bold red-text">Notice: </span>
    <span>previous invoice submission rejected. invoice revisions required. An email with details has been sent.</span>
</div>
<div class="row sub-section-title">
    <div class="col-12">
        <img src="/assets/images/icons/upload.svg" />
        <span>Submit Invoice</span>
    </div>
</div>
<div class="row sub-section-form">
    <div class="col-12">
        <app-upload-document (onFileAdded)="onFileAdded($event);" [elementId]="uploadDocumentId"></app-upload-document>
    </div>
    <div class="col-12 file-table" *ngFor="let document of documents">
        <i class="fas fa-file-invoice"></i>
        <span>{{document.file.name}} - </span>
        <span>{{document.file.size}} - </span>
        <span>{{document.file.type}}</span>
    </div>
    <div class="col-12 col-lg-6">
        <button type="button" class="btn btn-primary btn-lg col-md-12 col-xs-12 round-button font-mont-regular"
            (click)="onUploadInvoiceFile();" [disabled]="documents.length < 1" data-dismiss="modal">SUBMIT</button>
    </div>
</div>
<app-error-dialog [modalId]="modalId" [title]="messageTitle" [messageA]="messageMessageA"
    [messageB]="messageMessageB" [messageC]="messageMessageC" [messageAClass]="messageMessageAClass"
    [messageBClass]="messageMessageBClass" [messageCClass]="messageMessageCClass" [dialogClass]="dialogClass"
    (closeModal)="onCloseModal();">